// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import categoryReducer from './slices/categorySlice';
import productReducer from './slices/productSlice';
import wishListReducer from './slices/wishListSlice';
import authReducer from "./slices/authSlice";
import cartReducer from "./slices/cartSlice";
import attributeReducer from "./slices/attributeSlice"; 
import profileReducer from "./slices/profileSlice";
import addressReducer from "./slices/addressSlice";
import orderReducer from "./slices/orderSlice";
import ratingReducer from "./slices/ratingSlice";
import shippingReducer from "./slices/shippingSlice";
import watchAndBuyReducer from "./slices/watchAndBuySlice";
import blogReducer from "./slices/blogSlice";

const store = configureStore({
  reducer: {
    categories: categoryReducer,
    products: productReducer,
    wishList: wishListReducer,
    auth: authReducer,
    cart: cartReducer,
    attributes: attributeReducer,
    profiles: profileReducer,
    address: addressReducer,
    orders: orderReducer,
    ratings: ratingReducer,
    shipping: shippingReducer,
    watchAndBuy: watchAndBuyReducer,
    blogs: blogReducer,
  },
});

export default store;
